import axios from "axios";

// Формируем baseURL динамически из текущего протокола и хоста страницы
export const getBaseUrl = () => {
    const protocol = window.location.protocol; // 'http:' или 'https:'
    const host = window.location.hostname; // 'lk.rut-miit.ru' или 'lk-abit.miit.ru:3000'
    return `${protocol}//${host}`;
};

// Для обратной совместимости экспортируем BASE_URL как функцию
export const BASE_URL = getBaseUrl;

function axiosInstanceCreate() {
    const baseURL = getBaseUrl();

    const axiosInstance = axios.create({
        withCredentials: true,
        timeout: 30000,
        baseURL: baseURL,
    })

    axiosInstance.interceptors.response.use(response => {
        return response;
    }, error => {
        console.log(`AXISOS: ${JSON.stringify(error)}`);
        if (window.location.pathname.startsWith('/login')) {
            return Promise.reject(error)
        } else if (error.response.status !== null && error.response.status === 401) {
            if (window.location.pathname !== '/login') {
                window.location.href = '/login'
            }
        }
        return Promise.reject(error);
    })

    return axiosInstance;
}

const axiosInstance = axiosInstanceCreate()

export default axiosInstance
